/* One option picker for Build Your Map and Hole-in-One (snippets/ff-picker.liquid; owner 2026-10-27 "one way to build a
   frame"). FFPicker.init(root, opts) wires one picker:
     opts.price(style, size, frame) -> cents or null   full price of that print (shown under every Size and Frame pill)
     opts.art(style, el)                                 fills a Style tile's picture box (an <img>, or a background)
     opts.available(style) -> bool                       a style the course has (others are greyed out)
     opts.onChange({style, size, frame}, input)          after every pick
   Returns { get(), set({style, size, frame}), refresh() }; set() never calls onChange. */
(function () {
  if (window.FFPicker) return;
  function money(c) { var d = Number(c) / 100; return '$' + (Math.round(d) === d ? d : d.toFixed(2)); }
  function set_(root, opt) { return root.querySelector('[data-ff-option="' + opt + '"]'); }
  function value(root, opt) { var i = set_(root, opt) && set_(root, opt).querySelector('input:checked'); return i ? i.value : ''; }
  function init(root, opts) {
    if (!root) return null;
    if (root.ffPicker) return root.ffPicker;
    var o = opts || {};
    var ctl = {
      get: function () { return { style: value(root, 'Style'), size: value(root, 'Size'), frame: value(root, 'Frame') }; },
      set: function (v) {
        v = v || {};
        [['Style', v.style], ['Size', v.size], ['Frame', v.frame]].forEach(function (p) {
          if (!p[1]) return;
          var s = set_(root, p[0]);
          var inputs = s ? s.querySelectorAll('input') : [];
          for (var i = 0; i < inputs.length; i++) if (inputs[i].value === p[1] && !inputs[i].checked) inputs[i].checked = true;
        });
        ctl.refresh();
      },
      refresh: function () {
        var s = ctl.get();
        [['Size', function (x) { return o.price ? o.price(s.style, x, s.frame) : null; }],
         ['Frame', function (x) { return o.price ? o.price(s.style, s.size, x) : null; }]].forEach(function (p) {
          var fs = set_(root, p[0]);
          if (!fs) return;
          [].forEach.call(fs.querySelectorAll('label'), function (l) {
            var input = l.querySelector('input'), out = l.querySelector('[data-ff-price]');
            var c = p[1](input.value), txt = c != null && isFinite(c) ? money(c) : '';
            if (out && out.textContent !== txt) out.textContent = txt;
            var name = input.value + (txt ? ', ' + txt : '');
            if (input.getAttribute('aria-label') !== name) input.setAttribute('aria-label', name);
          });
        });
        var st = set_(root, 'Style');
        if (st) [].forEach.call(st.querySelectorAll('label'), function (l) {
          var input = l.querySelector('input'), art = l.querySelector('[data-ff-art]');
          var off = o.available ? o.available(input.value) === false : false;
          if (input.disabled !== off) input.disabled = off;
          if (art && o.art) o.art(input.value, art);
        });
      }
    };
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('input[type="radio"]')) return;
      ctl.refresh();
      if (o.onChange) o.onChange(ctl.get(), t);
    });
    root.ffPicker = ctl;
    ctl.refresh();
    return ctl;
  }
  window.FFPicker = { init: init, money: money };
})();
